var map = {
	"./activity.png": 63491,
	"./cause_risk.png": 34417,
	"./check_blue.png": 36267,
	"./coping_living.png": 80836,
	"./diagnosis.png": 28605,
	"./forward.png": 92697,
	"./lifestyle.png": 91495,
	"./medication.png": 22449,
	"./none.png": 73750,
	"./symptom.png": 31167,
	"./thanks.png": 94327,
	"./vital.png": 88308,
	"./welcome.png": 65134,
	"./zero.png": 31006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69178;